var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-4ba7e595": "",
    viewBox: "0 0 23 18",
    className: "ico__svg",
    focusable: "false",
    role: "img",
    "data-v-ico": "information-bet|events",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.3 17.2l.4-2.6.8.2-.4 2.5-.8-.1zm6-2.6l.4 2.6-.7.1-.4-2.5.7-.2z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.4 18h10.2c.2 0 .4-.2.4-.5s-.2-.5-.4-.5H6.4c-.2 0-.4.2-.4.5s.2.5.4.5z",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.1c0-.6.4-1.1.9-1.1h17.2c.5 0 .9.5.9 1.1v2.8c0 .6-.4 1.1-.9 1.1H2.9c-.5 0-.9-.5-.9-1.1V9.1zm0-6.2c0-.5.4-.9.9-.9h17.2c.5 0 .9.4.9 1V6c0 .5-.4 1-.9 1H2.9A.9.9 0 012 6V2.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23 1a1 1 0 00-1-1H1a1 1 0 00-1 1v13a1 1 0 001 1h21a1 1 0 001-1V1zm-1 1a1 1 0 00-1-1H2a1 1 0 00-1 1v11a1 1 0 001 1h19a1 1 0 001-1V2z",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.76eca2be74494dc63e1622f633cc3154.svg";
export { ForwardRef as ReactComponent };